import { useQuery } from '@tanstack/react-query';
import adminHttp from '../../../utils/adminHttp';


export function useGetAdminUsers() {
  const { data, isLoading, ...rest } = useQuery({
    queryKey: ["get all admin user list"],
    queryFn: async () => {
      const response = await adminHttp.get("admins/all");
      return response.data;
    },
    staleTime: Infinity,
  });
  return {
    data,
    isLoading,
    ...rest,
  }
}